export default __webpack_public_path__ + "static/media/CenterPic.7f3fb613.png";